import type { ConditionOperator } from '@ricoh/ria.client.core/constants/core/data.type';

import { CONDITION_OPERATOR_MAPPING } from '@ricoh/ria.client.core/constants/core/data';
import { ClientError } from '@ricoh/ria.client.core/errors';

/**
 * Prepare ConditionOperator.
 *
 * @param {string} operator Operator.
 *
 * @returns {ConditionOperator | undefined} ConditionOperator.
 */
export function prepareConditionOperator(operator: string): ConditionOperator | undefined {
  const conditionOperator = Object.entries<ConditionOperator, string[]>(CONDITION_OPERATOR_MAPPING).find(
    ([name, alias]) => name === operator || alias.includes(operator),
  );
  if (!conditionOperator) {
    return undefined;
  }

  return conditionOperator[0];
}

/**
 * Transform ConditionOperator.
 *
 * @param {ConditionOperator} conditionOperator ConditionOperator.
 *
 * @returns {string} Operator.
 */
export function transformConditionOperator(conditionOperator: ConditionOperator): string {
  const operator = CONDITION_OPERATOR_MAPPING[conditionOperator].at(0);
  if (!operator) {
    throw new ClientError({
      module: 'logic',
      message: 'Not found ConditionOperator',
      cause: conditionOperator,
    });
  }

  return operator;
}
